module.exports = "<nv-react-component component=\"ContentSearch\" style=\"height: 100%;\"></nv-react-component>";